var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("ellipse", {
      attrs: {
        cx: "20.019",
        cy: "20",
        rx: "19.4888",
        ry: "20",
        fill: _vm.color2,
      },
    }),
    _c("path", {
      attrs: {
        d: "M17.0957 28L24.4041 20.5L17.0957 13",
        stroke: _vm.color1,
        "stroke-width": "3",
        "stroke-linecap": "round",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }